import { render } from "./fabuxuenjia.vue?vue&type=template&id=6edcb5d5&scoped=true"
import script from "./fabuxuenjia.vue?vue&type=script&lang=js"
export * from "./fabuxuenjia.vue?vue&type=script&lang=js"

import "./fabuxuenjia.vue?vue&type=style&index=0&id=6edcb5d5&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edcb5d5"]])

export default __exports__